import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    individuals: [],
    questions: [],
    eligibleProducts: [],
    selections: [],
    rates: [],
    weeklyPremiumPreference: undefined,
    externalRoute: '/',
    maxTab: 1,
    summaryRows: [],
    showErrorDialog: false,
    totalWeeklyPremium: 0,
    totalLifePremium: 0,
    totalDFRPremium: 0,
    entityInfo: {
      agentName: '',
      agentNumber: '',
      agentPhone: '',
      entityDept: ''
    },
    payPeriodsRadio: '',
    payPeriodsOther: '',
    paycheckDeductions: 0,
    riders: [],
    cancerAppBuckets: [],
    cancerPlan: '',
    cancerPrimaryApplicant: {},
    employee: {},
    demographicsFlag: false,
    demographicsPage: 1,
    productsFlag: false,
    productsPage: 2,
    selectionsInfoCache: [],
    lpbAgent: {},
    lpb: {},
    lastLPB: {}
  },
  getters: {
    applicableIndividuals: state => {
      return state.individuals.filter(i => i.applicable === true)
    },
    getIndividualByIndex: state => idx => {
      return state.individuals[idx]
    },
    getIndividualByTypeAndChildIndex: state => (instype, childIdx) => {
      return state.individuals.find(
        i => i.type === instype && i.childIndex === childIdx
      )
    },
    getQuestionById: state => id => {
      return state.questions.find(q => q.questionId === id)
    }
  },
  mutations: {
    setLPB(state, lpb) {
      state.lpb = JSON.parse(JSON.stringify(lpb))
    },
    setLastLPB(state, lpb) {
      state.lastLPB = JSON.parse(JSON.stringify(lpb))
    },
    clearLPB(state) {
      state.lpb = {}
    },
    setLPBAgent(state, agentInfo) {
      state.lpbAgent = agentInfo
    },
    setselectionsInfoCache(state, sels) {
      state.selectionsInfoCache = []
      state.selectionsInfoCache.push(...sels)
    },
    clearselectionsInfoCache(state) {
      state.selectionsInfoCache = []
    },
    setDemographicsFlag(state, flag) {
      state.demographicsFlag = flag
    },
    setProductsFlag(state, flag) {
      state.productsFlag = flag
    },
    setDemographicsPage(state, page) {
      state.demographicsPage = page
    },
    setProductsPage(state, page) {
      state.productsPage = page
    },
    setEmployee(state, emp) {
      state.employee = emp
    },
    setEmployeeId(state, id) {
      state.employee.EmployeeId = id
    },
    setEmployeeName(state, employeeNames) {
      state.employee.LastName = employeeNames.lastName
      state.employee.FirstName = employeeNames.firstName
      state.employee.MiddleName = employeeNames.middleName
      // console.log(state.employee)
    },
    setEmployeeDOB(state, dob) {
      state.employee.DOB = dob // YYYYMMDD
      // console.log(state.employee)
    },
    setCancerAppBuckets(state, buckets) {
      state.cancerAppBuckets = []
      state.cancerAppBuckets.push(...buckets)
    },
    setCancerPlan(state, plan) {
      state.cancerPlan = plan
    },
    setCancerPrimaryApplicantRate(state, rate) {
      if (rate == undefined) state.cancerPrimaryApplicant.rate = undefined
      else state.cancerPrimaryApplicant.rate = JSON.parse(JSON.stringify(rate))
    },
    setCancerPrimaryApplicant(state, primaryApplicant) {
      state.cancerPrimaryApplicant = JSON.parse(
        JSON.stringify(primaryApplicant)
      )
    },
    clearRiders(state) {
      state.riders = []
    },
    addRider(state, rider) {
      state.riders.push(rider)
    },
    setPayPeriodsOther(state, val) {
      state.payPeriodsOther = val
    },
    setPaycheckDeductions(state, val) {
      state.paycheckDeductions = val
    },
    setPayPeriodsRadio(state, val) {
      state.payPeriodsRadio = val
    },
    setEntityInfo(state, info) {
      state.entityInfo = JSON.parse(JSON.stringify(info))
    },
    setEntityDept(state, dept) {
      state.entityInfo.entityDept = dept
    },
    setTotalWeeklyPremium(state, val) {
      state.totalWeeklyPremium = val
    },
    setTotalLifePremium(state, val) {
      state.totalLifePremium = val
    },
    setTotalDFRPremium(state, val) {
      state.totalDFRPremium = val
    },
    setShowErrorDialog(state, newVal) {
      state.showErrorDialog = newVal
    },
    setMaxTab(state, newTabIdx) {
      state.maxTab = newTabIdx
    },
    setWeeklyPremiumPreference(state, amt) {
      state.weeklyPremiumPreference = amt
    },
    clearRates(state) {
      state.rates = []
    },
    addRate(state, rate) {
      state.rates.push(rate)
    },
    addSelection(state, sel) {
      state.selections.push(sel)
    },
    clearSelections(state) {
      state.selections = []
    },
    addSummaryRow(state, row) {
      state.summaryRows.push(row)
    },
    clearSummaryRows(state) {
      state.summaryRows = []
    },
    addIndividual(state, ind) {
      state.individuals.push(ind)
    },
    removeIndividual(state, ind) {
      let idx = state.individuals.findIndex(
        i => i.type === ind.type && i.childIndex === ind.childIndex
      )

      if (idx >= 0) {
        state.individuals.splice(idx, 1)
      }
    },
    updateIndividual(state, ind) {
      let idx = state.individuals.findIndex(
        i => i.type === ind.type && i.childIndex === ind.childIndex
      )
      state.individuals.splice(idx, 1, ind)
    },
    addQuestion(state, question) {
      state.questions.push(question)
    },
    removeQuestion(state, idx) {
      state.questions.splice(idx, 1)
    },
    updateQuestion(state, question) {
      let idx = state.questions.findIndex(
        q => q.questionId === question.questionId
      )
      state.questions.splice(idx, 1, question)
    },
    addProduct(state, prod) {
      state.eligibleProducts.push(prod)
    },
    removeProduct(state, idx) {
      state.eligibleProducts.splice(idx, 1)
    },
    clearProducts(state) {
      state.eligibleProducts = []
    },
    updateExternalRoute(state, route) {
      state.externalRoute = route
    }
  },
  actions: {}
})
